import styled from 'styled-components'
import {NavDropdown} from 'react-bootstrap'
import booksitoutIcon from '../../config/BooksitoutIcon'
import useLoginStore from '../../routes/login/useLoginStore'
import BooksitoutImages from '../../images/BooksitoutImages'
import useFeedbackStore from '../../routes/feedback/useFeedbackStore'
import {BooksitoutServer} from '../../config/BooksitoutServer'
import {useNavigate} from 'react-router-dom'

const TopnavUserIcon = () => {
	let navigate = useNavigate()

	const isLoggedIn = useLoginStore(state => state.isLoggedIn())
	const refreshToken = useLoginStore(state => state.refreshToken)
	const logout = useLoginStore(state => state.logout)

	const handleLogout = () => {
		BooksitoutServer.post(`/v1/logout?refreshToken=${refreshToken}`, { refreshToken: refreshToken }).then(_ => logout(true, navigate))
	}

	const iconSrc = localStorage.getItem('appUsers-image') == null || localStorage.getItem('appUsers-image') === '' ? BooksitoutImages.Placeholder.user : localStorage.getItem('appUsers-image') ?? ''

	const { open: openFeedback } = useFeedbackStore()

	return (
		<NavContainer title={<Icon src={iconSrc} />}>
			{!isLoggedIn ? (
				<>
					<NavItem onClick={openFeedback}>
						<booksitoutIcon.faq className="text-book me-2 mb-1 bold" />
						제안 / 피드백
					</NavItem>

					<NavDivider />

					<NavItem href="/login">
						<booksitoutIcon.login className="text-book me-2 mb-1" />
						로그인 + 회원가입
					</NavItem>
				</>
			) : (
				<>
					<NavItem onClick={openFeedback}>
						<booksitoutIcon.suggestion className="text-book me-2 mb-1 bold" />
						제안 / 피드백
					</NavItem>

					<NavDivider />

					<NavItem href="/users/me/redirect">
						<booksitoutIcon.user className="text-book me-2 mb-1" />내 프로필
					</NavItem>

					<NavItem href="/settings">
						<booksitoutIcon.settings className="text-book me-2 mb-1" />
						설정
					</NavItem>

					<NavItem onClick={() => handleLogout()}>
						<booksitoutIcon.login className="text-book me-2 mb-1" />
						로그아웃
					</NavItem>
				</>
			)}
		</NavContainer>
	)
}

const NavContainer = styled(NavDropdown).attrs({
	className: 'd-md-block',
	align: 'end',
})`
	padding: 0;
	margin: 0;

	.dropdown-menu {
		background-color: var(--card-bg-color);
		border: none;
		border-radius: 16px;
		box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
		padding: 8px 0;
		min-width: 200px;
		overflow: hidden;

		top: 60px !important;
		right: auto !important;
		transform: translateX(-110px) !important;
		bottom: auto !important;
		left: auto !important;

	}
`

const NavItem = styled(NavDropdown.Item)`
	color: var(--text-color);
	padding: 12px 20px;
	font-size: 15px;
	font-weight: 500;
	transition: background-color 0.15s ease;

	&:hover, &:focus {
		background-color: var(--hover-bg-color);
		color: var(--text-color);
	}

	&:active {
		background-color: var(--hover-bg-color);
		color: var(--text-color);
	}
`

const NavDivider = styled(NavDropdown.Divider)`
	&.dropdown-divider {
		border-top: 1px solid var(--hover-bg-color);
		margin: 4px 0;
	}
`

const Icon = styled.img.attrs({
	className: 'img-fluid',
	alt: '',
})`
	width: 20px;
	height: 20px;
	padding: 0;
	margin: 0;
	border-radius: 6px;
`

export default TopnavUserIcon
